import { Box, Stack } from '@mui/material'
import { tokens } from 'ComponentLibrary'
import { TextWithEllipsis } from '../TextWithEllipsis/TextWithEllipsis'
import { ReactNode } from 'react'

type LabeledValueProps = {
    size: 'small' | 'medium' | 'large'
    alignRight?: boolean
    value: string
    unit?: string
    color?: string
    subheadline?: string
    maxWidth?: string
    endAdornment?: ReactNode
}

export function LabeledValue({ size, alignRight, value, unit, subheadline, maxWidth, color, endAdornment }: LabeledValueProps) {
    const actualMaxWidth = endAdornment ? `calc(${maxWidth} - ${tokens.SizingIconM})` : maxWidth

    return (
        <Stack direction="row" width="100%" alignItems="center" justifyContent="space-between">
            <Stack direction="column" gap={tokens.SizingSpacing050} alignItems={alignRight ? 'flex-end' : 'flex-start'}>
                <Box maxWidth={actualMaxWidth}>
                    <TextWithEllipsis
                        tooltipText={`${value} ${unit || ''}`}
                        typographyProps={{
                            color: color || tokens.ColorTextBoldest,
                            variant: size === 'small' ? 'valueS' : size === 'medium' ? 'valueM' : 'valueL',
                        }}
                    >
                        {value}
                        {unit && (
                            <Box
                                component="span"
                                sx={{
                                    marginLeft: tokens.SizingSpacing050,
                                    ...tokens.TextS,
                                    color: tokens.ColorTextSubtle,
                                }}
                            >
                                {unit}
                            </Box>
                        )}
                    </TextWithEllipsis>
                </Box>
                {subheadline && (
                    <Box maxWidth={actualMaxWidth}>
                        <TextWithEllipsis
                            tooltipText={subheadline}
                            typographyProps={{
                                color: tokens.ColorTextSubtle,
                                variant: 'textS',
                            }}
                        >
                            {subheadline}
                        </TextWithEllipsis>
                    </Box>
                )}
            </Stack>
            {endAdornment}
        </Stack>
    )
}
